import Ws from "../../providers/Ws";


export default class FromServer {

    getBeneficiari = async () => {
        let ws = new Ws();


        let beneficiari = await ws.customSelect(`select b.id as id_beneficiar , b.nume as nume_beneficiar, a.id as id_administrator,a.nume as nume_administrator
            from beneficiari b left outer join beneficiari_administratori a on (b.id = a.id_beneficiar)`, {
                p1: 1
            })

        if (beneficiari.Succes) {
            // console.log('beneficiari :', beneficiari);

            let cloneBeneficiari = beneficiari.Content

            cloneBeneficiari.push({
                nume_beneficiar: 'Beneficiar Nou',
                id_beneficiar: null,
                nume_administrator: null,
                id_administrator: null
            })
            return { r: true, m: beneficiari.Messsage, c: cloneBeneficiari, }
        } else {
            return { r: false, m: beneficiari.Messsage, c: [] }
        }

    }


    updateBeneficiar = async (cols, where) => {
        let ws = new Ws();

        let update = await ws.update('beneficiari', cols, where)

        if (update.Succes) {
            return { r: true, m: update.Messsage }
        } else {
            return { r: false, m: update.Messsage }
        }


    }


    insertBeneficiar = async (cols) => {

        let ws = new Ws();

        let insert = await ws.insert('beneficiari', cols)

        if (insert.Succes) {
            return { r: true, m: insert.Messsage, c: insert.Content[0].id }
        } else {
            return { r: false, m: insert.Messsage, c: null }
        }
    }

    updateAdministrator = async (cols, where) => {
        let ws = new Ws();

        let update = await ws.update('beneficiari_administratori', cols, where)

        if (update.Succes) {
            return { r: true, m: update.Messsage, c: update.Content }
        } else {
            return { r: false, m: update.Messsage, c: null }
        }
    }


    insertAdministrator = async (cols) => {

        let ws = new Ws();

        let insert = await ws.insert('beneficiari_administratori', cols)

        if (insert.Succes) {
            return { r: true, m: insert.Messsage, c: insert.Content }
        } else {
            return { r: false, m: insert.Messsage, c: null }
        }

    }

    getAdmin = async (id) => {
        let ws = new Ws();

        let getAdmin = await ws.customSelect(`select * from beneficiari_administratori where id_beneficiar = @p1`, {
            p1: id
        })

        if (getAdmin.Succes) {
            return { r: true, m: getAdmin.Messsage, c: getAdmin.Content }
        } else {
            return { r: false, m: getAdmin.Messsage, c: null }
        }
    }

    updateDetaliiAdmin = async (objToUpdate) => {
        let ws = new Ws();


        let objUpdate = {
            adresa: objToUpdate.adresa || '',
            clasa_sociala: objToUpdate.clasa_sociala || '',
            educatie: objToUpdate.educatie || '',
            id_beneficiar: objToUpdate.id_beneficiar || '',
            limba: objToUpdate.limba || '',
            nationalitate: objToUpdate.nationalitate || '',
            note: objToUpdate.note || '',
            nr_membrii_familie: objToUpdate.nr_membrii_familie || '',
            nume: objToUpdate.nume || '',
            ocupatie: objToUpdate.ocupatie || '',
            oras: objToUpdate.oras || '',
            rasa: objToUpdate.rasa || '',
            religie: objToUpdate.religie || '',
            sex: objToUpdate.sex || '',
            stil_de_viata: objToUpdate.stil_de_viata || '',
            venit: objToUpdate.venit || ''
        }
        let update = await ws.update('beneficiari_administratori', objUpdate, {id: objToUpdate.id})

        if(update.Succes){
            return {r:true, m:update.Messsage, c:update.Content}
        }else{
            return {r:false, m:update.Messsage, c:null}
        }
    }

}